<template>
  <div class="n-card-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: `NCardHeader`,
};
</script>

<style lang="scss" scoped>
  $nCardHeaderHeight: 40px;
  .n-card-header {
    padding: 0px 15px;
    font-weight: 500;
    border-bottom: 2px solid #DDDDDD;
    height: $nCardHeaderHeight;
    line-height: $nCardHeaderHeight;
  }
</style>
